module.exports = __webpack_public_path__ + "img/profile-pic (11).f9e34128.png";